<script lang="ts">
    import type { ProjectInfo_TableRow } from '$lib/../gen/graphql';
    import { browser } from '$app/env';
    import { page } from '$app/stores';
    import ShareThisPage from './ShareThisPage.svelte';
    import { onMount } from 'svelte';

    export let title: string;
    export let subTitle = '';
    export let artists = '';
    export let locationName: string = '';
    export let curator: string = '';
    export let photographer: string = '';
    export let textAuthor: string = '';
    export let locationLink = '';
    export let topColor = 'transparent';
    export let bottomColor = 'transparent';
    export let projectInfo: ProjectInfo_TableRow[] = [];

    /**
     * Check if current session runs in
     * a mobile webkit instance.
     */
    let containerMinHeight = isMobileWebkit() ? '-webkit-fill-available' : '100vh';

    export function isMobileWebkit() {
        if (browser) {
            const ua = window.navigator.userAgent;
            const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            const webkit = !!ua.match(/WebKit/i);
            return iOS && webkit && !ua.match(/CriOS/i);
        } else {
            return false;
        }
    }
    onMount(() => {
        containerMinHeight = isMobileWebkit() ? '-webkit-fill-available' : '100vh';
    });
</script>

<section class="grid h-screen min-h-screen bg-beige" style:min-height={containerMinHeight}>
    <div
        style:background={topColor}
        class="grid place-content-center space-y-20 p-5 text-center text-3xl md:text-5xl lg:text-6xl"
    >
        {#if artists}
            <h2 class="space-x-7">
                {artists}
            </h2>
        {/if}
        <h1 class="uppercase">{title}</h1>
    </div>
    <div
        style:background={bottomColor}
        class="bg-yellow-200 p-5 text-xl leading-6 md:text-2xl md:leading-tight"
    >
        <h3>Project Info</h3>
        <ul class="mb-5 pl-5">
            {#if projectInfo}
                {#each projectInfo as info}
                    <li>{@html info.projectInfo}</li>
                {/each}
            {/if}
            {#if locationName}
                <li title="location name">💙 <a href={locationLink}>{locationName}</a></li>
            {/if}
            {#if curator}
                <li title="curator">💚 {curator}</li>
            {/if}
            {#if artists}
                <li title="artist(s)">🖤 {artists}</li>
            {/if}
            {#if textAuthor}
                <li title="text author(s)">💜 {textAuthor}</li>
            {/if}
            {#if photographer}
                <li title="photographer">💛 {photographer}</li>
            {/if}
        </ul>
        <ShareThisPage
            title={`KUBAPARIS | ${title}`}
            text={subTitle || artists}
            url={$page.url.href}
        />
    </div>
</section>

<style>
    section {
        grid-column: full !important;
        grid-template-rows: 2fr min-content;
    }

    h3:not(:first-child) {
        @apply mt-5;
    }

    ul :global(a) {
        @apply text-blue;
    }
</style>
